const MonitoringDashboard = () => import('../screens/MonitoringDashboard/MonitoringDashboard.vue');

export default [
  {
    component: MonitoringDashboard,
    meta: {
      activeSidebarItemId: 'monitoring-dashboard',
      authority: ['merchants:view', 'transactions:view', 'payments:view'],
      pageTitle: 'Monitoring Dashboard',
    },
    name: 'monitoring-dashboard',
    path: '/monitoring-dashboard',
  },
];
